module.exports = __webpack_public_path__ + "static/media/sales-screen-pic.6da30809.png";